<template>
  <div class="page-container">
    <div class="query-title">产品数据查询&修改</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="export" tip="导出" @click="exportExcel" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
            <template #product_id="{ row }">
              <span class="blue" @click="toDetail(row)">{{ row.product_id }}</span>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import { getProductList } from '@/api/sap/client-sap'
import tableMixins from '@/utils/tableMixins'
import pageConfig from './config/mdmProductQuery'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [],
        data: []
      },
      searchField: {},
      isSetFilter: false
    }
  },
  created() {
    this.initPage(pageConfig)
  },
  methods: {
    toDetail(row) {
      this.$router.push({
        path: '/wly/master-data-product/info-check',
        query: {
          id: row.product_id
        }
      })
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        partner: this.$store.getters.role.USER_BP,
        // role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data, total, calculation, field } = await getProductList(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    // 导出全部 导出本页
    async exportExcel() {
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        ...this.allConditions
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, getProductList)
      frontExport(this.gridOptions.columns, data, '产品数据')
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>

<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/product-manage/mdmProductQuery.vue